import React, { memo, useCallback } from "react";
import Accordion, { useAccordion } from 'svift-library/client/accordion/Accordion';
import Section from '../Section';
import Preset from 'components/editor-v2/editor-interface/options/common/preset';
import BackgroundOptions from 'components/editor-v2/editor-interface/options/common/background';
import BackgroundVideoOptions from 'components/editor-v2/editor-interface/options/common/background-video';

export default memo(props => {
    const { editableNode: node, updateState } = props;
    const [state, dispatch] = useAccordion();

    const onChange = useCallback((key, value, ...args) => {
        updateState(context => {
            return {
                ...context,
                nodeMap: {
                    ...context.nodeMap,
                    [node.id]: {
                        ...context.nodeMap[node.id],
                        props: {
                            ...context.nodeMap[node.id].props,
                            [key]: value
                        }
                    }
                }
            };
        }, ...args);
    }, []);

    // console.log(node.props, 'node props body options');

    return (
        <React.Fragment>
            <Section>
                <Preset
                    presets={props.theme.presets.container}
                    onChange={onChange}
                    presetKey={node.props.preset || 'Primary'}
                    theme={props.theme} 
                    inlineStyling={node.props.style}
                />
            </Section>

            <Accordion state={state} dispatch={dispatch}>
                <BackgroundVideoOptions {...props} />
                <BackgroundOptions {...props} />
            </Accordion>
        </React.Fragment>
    );
});